import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-message-forwarded-label",
  templateUrl: "./message-forwarded-label.component.html",
  styleUrls: ["./message-forwarded-label.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MessageForwardedLabelComponent {}
